<template>
  <van-overlay :show="value" :lockScroll="isScroll">
    <div class="m-pop-box">
      <van-sticky>
        <van-search
            v-model="inputVal"
            show-action
            placeholder="请输入搜索关键词"
            @input="inputChange"
            @cancel="onCancel"
        />
      </van-sticky>
      <div class="m-content" @click.stop="">
        <div class="m-nav-box" v-for="(item,index) in modelList" :key="index">
          <div v-show="!item.show" class="m-nav" @click="confirm(item)"><span>{{item[valueKey]}}</span></div>
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script>

  export default {
    props: {
      value: {
        type: Boolean,
        default: false
      },
      isScroll:{
        type: Boolean,
        default: false
      },
      modelList:{
        type: Array,
        default: () => []
      },
      valueKey:{
        type: String,
        default: 'label'
      }
    },
    components: {},
    computed:{
     
    },
    data () {
      return {
        inputVal: '',
//        selectList:[]
      }
    },
    created () {

    },
    methods: {
      inputChange(val){
        if(val){
          const pattern = new RegExp(val, 'i'); // 不区分大小写
          this.modelList.forEach((item)=>{
            if(!(pattern.test(item[this.valueKey]))){
              item.show = true
            }else {
              item.show = false
            }
          })
        }else {
          this.modelList.forEach((item)=>{
            item.show = false
          })
        }
      },
      onCancel(){
        this.$emit('input', false)
      },
      confirm(i){
        this.$emit('confirm', i)
//        this.$emit('input', false)
      }
    },
    mounted () {

    },
    watch:{
//      modelList: {
//        handler(val) {
//          if (val ) {
//            this.selectList = [...this.modelList]
//          }
//        },
//        immediate: true,
//      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  .m-pop-box{
    width: 100%;
    height: 100%;
    background: #F4F6F9;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    .m-content{
      margin-top: 13px;
      background: #ffffff;
      width: 100%;
      /*height: 100vh;*/
      padding: 0px 15px;
      /*overflow-y: auto;*/
      .m-nav-box{
        .m-nav{
          padding: 15px 0;
          border-bottom: 1Px solid #E7E7E7;
        }
      }
      .m-nav-box:last-child{
        .m-nav{
          border-bottom: none;
        }
      }
    }
  }
</style>

